import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "icon"];

  toggle() {
    if (!this.hasInputTarget) return;

    if (this.inputTarget.type === "password") {
      this.inputTarget.type = "text";
      if (this.hasIconTarget) {
        this.iconTarget.classList.remove("fa-eye");
        this.iconTarget.classList.add("fa-eye-slash");
      }
    } else {
      this.inputTarget.type = "password";
      if (this.hasIconTarget) {
        this.iconTarget.classList.remove("fa-eye-slash");
        this.iconTarget.classList.add("fa-eye");
      }
    }
  }
}
